import { Filters } from '@/types/filter'
import { FilterPanelData } from '../types'

export function buildFiltersFromData(data: FilterPanelData): Filters {
  const createdBy =
    data.createdBy === 'AGENT' || data.createdBy === 'PLATFORM' ? data.createdBy : undefined
  return {
    search: '',
    territories: data.territoriesIds.join(';'),
    contexts: data.contextsIds.join(';'),
    topics: data.topicsIds.join(';'),
    partners: data.partnersIds.join(';'),
    sources: data.sourcesIds.join(';'),
    favorited: data.favorited,
    created_by: createdBy,
  }
}

export function buildEmptyFilters(): Filters {
  return {
    search: '',
    territories: '',
    contexts: '',
    topics: '',
    partners: '',
    sources: '',
    favorited: undefined,
    created_by: undefined,
  }
}
